import request from '@/utils/request'

import qs from 'qs'

// 企业信息搜索
export function searchEnterprise({ keyword, type, current, size = 10 }) {
  return request({
    url: '/search/enterprise',
    method: 'get',
    params: {
      keyword,
      type,
      current,
      size,
    },
  })
}

// 文章搜索
export function searchArticle({ keyword, current, size = 10 }) {
  return request({
    url: '/search/article',
    method: 'get',
    params: {
      keyword,
      current,
      size,
    },
  })
}

// 专题文章
export function articleTopics(data) {
  return request({
    url: `/creditArticleTopics/page`,
    params: data,
  })
}

export function articleTopicsDetail({ id }) {
  return request({
    url: `/creditArticleTopics/${id}`,
  })
}

export function articleTopicsHot() {
  return request({
    url: `/creditNotices/hots`,
  })
}

// 热门文章 - start
// 通知公告
export function getNoticesHot() {
  return request({
    url: `/creditNotices/hots`,
  })
}

// 行业信用
export function getIndustriesHot(data) {
  return request({
    url: '/creditArticleIndustries/hots',
    method: 'get',
    params: data,
  })
}

// 行业信用
export function downLoadFile(data) {
  return request({
    url: '/file/download',
    method: 'get',
    responseType: 'blob',
    params: data,
  })
}

// 诚信宣传
export function getTypicalHot(data) {
  return request({
    url: '/creditArticleTypical/hots',
    method: 'get',
    params: data,
  })
}

// 政策法规
export function getPoliciesHot(data) {
  return request({
    url: '/creditArticlePolicies/hots',
    method: 'get',
    params: data,
  })
}
// 联合奖惩
export function getRewardPunishesHot(data) {
  return request({
    url: '/creditArticleRewardPunishes/hots',
    method: 'get',
    params: data,
  })
}
// 信用研究
export function getResearchesHot(data) {
  return request({
    url: '/creditArticleResearches/hots',
    method: 'get',
    params: data,
  })
}
// 专项治理
export function getSpecialsHot(data) {
  return request({
    url: '/creditArticleSpecials/hots',
    method: 'get',
    params: data,
  })
}
// 风险提示
export function getRisksHot(data) {
  return request({
    url: '/creditArticleRisks/hots',
    method: 'get',
    params: data,
  })
}
// 信用动态
export function getDynamicsHot(data) {
  return request({
    url: '/creditArticleDynamics/hots',
    method: 'get',
    params: data,
  })
}

// 热门文章 - end
export function getNewsSearch({ keywords, page }) {
  return request({
    url: `/news/search`,
    method: 'get',
    params: {
      keywords,
      page,
    },
  })
}

export function commonLinks() {
  return request({
    url: `/common/links`,
    method: 'get',
  })
}

// 22/2/23
export function getSwiper() {
  return request({
    url: `/creditBanners`,
    method: 'get',
  })
}
// 首页
export function getIndex() {
  return request({
    url: `/home/index`,
    method: 'get',
  })
}

export function login(data) {
  return request({
    url: '/login',
    method: 'post',
    data,
  })
}

export function register(data) {
  return request({
    url: '/members/register',
    method: 'post',
    data,
  })
}

export function logout() {
  return request({
    url: '/logout',
    method: 'post',
  })
}

export function getUserInfo() {
  return request({
    url: `/members/info`,
  })
}

export function queryFeedBack(data) {
  return request({
    url: `/members/feedback/page`,
    method: 'get',
    params: data,
  })
}

// 用户反馈
export function feedback(data) {
  return request({
    url: `/members/feedback`,
    method: 'post',
    data,
  })
}

export function changePw(data) {
  return request({
    url: `/members/password/update`,
    method: 'post',
    data,
  })
}

// 实名认证
export function certification(data) {
  return request({
    url: `/members/certification`,
    method: 'post',
    data,
  })
}

// 企业认领
export function enterpriseClaim(data) {
  return request({
    url: `/members/enterpriseClaim`,
    method: 'post',
    data,
  })
}

export function enterpriseClaimPage(data) {
  return request({
    url: `/members/enterpriseClaim/page`,
    method: 'get',
    params: data,
  })
}

// 字典查询
// 信用动态 creditDynamic，政策法规 creditPolicy，专项治理 special，行业信用 industry
export function getCode({ code }) {
  return request({
    url: `/dictionaryTypes/${code}/data`,
  })
}

// 信用动态
export function getDynamic({ category, size, current }) {
  return request({
    url: `/creditArticleDynamics/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

export function getDynamicDetail({ id }) {
  return request({
    url: `/creditArticleDynamics/${id}`,
    method: 'get',
  })
}

// 行业信用
export function getIndustries({ category, size, current }) {
  return request({
    url: `/creditArticleIndustries/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

export function getIndustriesDetail({ id }) {
  return request({
    url: `/creditArticleIndustries/${id}`,
    method: 'get',
  })
}

// 诚信宣传
export function getTypical({ size, current, category }) {
  return request({
    url: `/creditArticleTypical/page`,
    method: 'get',
    params: {
      size,
      current,
      category,
    },
  })
}

export function getTypicalDetail({ id }) {
  return request({
    url: `/creditArticleTypical/${id}`,
    method: 'get',
  })
}

// 政策法规
export function getPolicies({ category, size, current }) {
  return request({
    url: `/creditArticlePolicies/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

export function getPoliciesDetail({ id }) {
  return request({
    url: `/creditArticlePolicies/${id}`,
    method: 'get',
  })
}

// 信用研究
export function getResearches({ size, current }) {
  return request({
    url: `/creditArticleResearches/page`,
    method: 'get',
    params: {
      size,
      current,
    },
  })
}

export function getResearchesDetail({ id }) {
  return request({
    url: `/creditArticleResearches/${id}`,
    method: 'get',
  })
}

// 专项治理
export function getSpecials({ category, size, current }) {
  return request({
    url: `/creditArticleSpecials/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

export function getSpecialsDetail({ id }) {
  return request({
    url: `/creditArticleSpecials/${id}`,
    method: 'get',
  })
}

// 风险提示
export function getRisks({ category, size, current }) {
  return request({
    url: `/creditArticleRisks/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

export function getRisksDetail({ id }) {
  return request({
    url: `/creditArticleRisks/${id}`,
    method: 'get',
  })
}
// 合同履约
export function getContracts({ contractNumber, current,size }) {
  return request({
    url: '/creditContractSupervision/page',
    method: 'get',
    params: {
      contractNumber,
      current,
      size,
    },
  })
}
export function getContractsDetail({ id }) {
  return request({
    url: `/creditContractSupervision/${id}`,
    method: 'get',
  })
}
// 通知公告
export function getNotices({ category = undefined, size, current }) {
  return request({
    url: `/creditNotices/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

export function getNoticesDetail({ id }) {
  return request({
    url: `/creditNotices/${id}`,
    method: 'get',
  })
}

//联合奖惩
export function getPunishes({ category, size, current }) {
  return request({
    url: `/creditArticleRewardPunishes/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}
export function getPunishesDetail({ id }) {
  return request({
    url: `/creditArticleRewardPunishes/${id}`,
  })
}

//信易+
export function getLetterEasy({ category, size, current }) {
  return request({
    url: `/creditLetterEasy/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

// 咨询公示
export function getCreditRealTimeInfo({ category, size, current }) {
  return request({
    url: `/creditRealTimeInfo/page`,
    method: 'get',
    params: {
      category,
      size,
      current,
    },
  })
}

// 獲取咨詢公示詳情
export function getCreditRealTimeDetail({ id }) {
  return request({
    url: `/creditRealTimeInfo/${id}`,
  })
}

//获取自主申报历史
export function getHistory() {
  return request({
    url: `/creditMemberEnterpriseClaims/getHistory`,
    method: 'get',
  })
}

//信易+
export function getLetterEasyDetail({ id }) {
  return request({
    url: `/creditLetterEasy/${id}`,
  })
}

export function getLetterEasyHot(data) {
  return request({
    url: '/creditLetterEasy/hots',
    method: 'get',
    params: data,
  })
}

// 底部链接
export function getFooter() {
  return request({
    url: `/home/footer`,
  })
}

// 组织机构（红黑名单使用）
export function getOrganization() {
  return request({
    url: `/organizes`,
  })
}

// 事项
export function getMatters(data) {
  return request({
    url: `/creditRosterMatters`,
    method: 'get',
    params: data,
  })
}

// 红名单
export function redList(data) {
  return request({
    url: '/creditRosterListReds/page',
    method: 'get',
    params: data,
  })
}
//行政裁决
export function adjuList(data) {
  return request({
    url: '/creditAdjuList/page',
    method: 'get',
    params: data,
  })
}
//司法判决
export function courtDecisionList(data) {
  return request({
    url: '/courtDecisionList/page',
    method: 'get',
    params: data,
  })
}

//信用评价等级
export function creditLevelList(data) {
  return request({
    url: `/enterprise/list`,
    method: 'get',
    params: data,
  })
}


//学校食堂信用评级
export function schoolcafeteriacreditratingList(data) {
  return request({
    url: `/schoolcafeteriacreditrating/list`,
    method: 'get',
    params: data,
  })
}
// 黑名单
export function blackList(data) {
  return request({
    // url: `/creditRosterListBlacks/page`,
    url: `/creditLoseExecutes/page`,
    method: 'get',
    params: data,
  })
}

// 图片验证码
export function getCaptchaImg(data) {
  return request({
    url: `/captcha/image`,
    params: data,
  })
}

//短信验证码
export function getCaptchaSms(data) {
  return request({
    url: `/captcha/sms`,
    method: 'post',
    data,
  })
}

export function upload(data) {
  return request({
    url: `/file/upload`,
    method: 'post',
    data,
  })
}

// 政务承诺
export function promiseInfo(data) {
  return request({
    url: `/creditPromiseInfo/page`,
    params: data,
  })
}

// 信用承诺
export function promiseList(data) {
  return request({
    url: `/creditPromiseList/page`,
    params: data,
  })
}

export function promiseDetail(data) {
  return request({
    url: `/creditPromiseFulFill/page`,
    method: 'get',
    params: data,
  })
}

// 申报信用承诺
export function createPromise(data) {
  return request({
    url: `/creditPromiseList`,
    method: 'post',
    data,
  })
}

// 我的承诺
export function promiseMatters(data) {
  return request({
    url: `/creditPromiseMatters`,
    params: data,
  })
}

// 双公示
export function bothPublic(data) {
  return request({
    url: `/creditPairPublicity/page`,
    params: data,
  })
}

// 失信被执行人
export function losePeople(data) {
  return request({
    url: `/creditLoseExecutes/page`,
    params: data,
  })
}

// 22/2/27
// 企业信息
export function enterprise(data) {
  return request({
    url: `/enterprise/details`,
    params: data,
  })
}

export function count(data) {
  return request({
    url: `/enterprise/count`,
    params: data,
  })
}

// 企业 行政许可
export function permit(data) {
  return request({
    url: `/enterprise/permit`,
    params: data,
  })
}

// 企业 行政处罚
export function punish(data) {
  return request({
    url: `/enterprise/punish`,
    params: data,
  })
}

// 企业 红名单
export function companyRedList(data) {
  return request({
    url: `/enterprise/redList`,
    params: data,
  })
}

// 企业 黑名单
export function companyBlackList(data) {
  return request({
    url: `/enterprise/blackList`,
    params: data,
  })
}

// 企业异常名录
export function abnormal(data) {
  return request({
    url: `/enterprise/abnormalList`,
    params: data,
  })
}

// 提起申诉
export function creditObjectionAppeals(data) {
  return request({
    url: `/creditObjectionAppeals`,
    method: 'post',
    data,
  })
}

// 我的异议申诉
// 0 待受理，1 受理中，2 已回复 ，3 已驳回，4 已取消
export function myAppealsList(data) {
  return request({
    url: `/creditObjectionAppeals/my`,
    method: 'get',
    params: data,
  })
}

// 异议申诉列表
export function appealsList(data) {
  return request({
    url: `/creditObjectionAppeals/list`,
    params: data,
  })
}

// 取消异议申诉
export function cancelAppeal({ id }) {
  return request({
    url: `/creditObjectionAppeals/${id}/cancel`,
    method: 'put',
  })
}

// 异议申诉详情
export function appealDetail({ id }) {
  return request({
    url: `/creditObjectionAppeals/${id}`,
  })
}

// 企业经营异常名录
export function abnormalList(data) {
  return request({
    url: `/creditEnterpriseAbnormalList/page`,
    params: data,
  })
}

// 信用报告下载
export function downloadCreditReport(data) {
  return request({
    url: `/enterprise/downloadCreditReport`,
    params: data,
  })
}

// 检查是否认领当前企业
export function checkEnterpriseClaim(data) {
  return request({
    url: `/enterprise/checkEnterpriseClaim`,
    params: data,
  })
}

// 下载文件
export function fileDownload(data) {
  return request({
    url: `/file/download`,
    method: 'get',
    params: data,
  })
}

// 企业认领列表，信用承诺选择主体时需要用到
export function creditMemberEnterpriseClaims(data) {
  return request({
    url: `/creditMemberEnterpriseClaims`,
  })
}

// 承诺事项
export function getPromiseMatters(data) {
  return request({
    url: `/creditPromiseMatters`,
    params: data,
  })
}

// 我的承诺
export function getMyPromise(data) {
  return request({
    url: `/members/enterprisePromise/page`,
    params: data,
  })
}

// 通过字典分类code查询字典列表
export function dictionaryTypes(data) {
  const { code = 'topic', category } = data
  return request({
    url: `/dictionaryTypes/${code}/categories/${category}`,
  })
}

// 修改手机号
export function changeMobile(data) {
  return request({
    url: `/members/mobile/update`,
    method: 'post',
    data,
  })
}

// 忘记密码
export function forgetPw(data) {
  return request({
    url: `/members/password/forget`,
    method: 'post',
    data,
  })
}

// 浏览量
export function getView() {
  return request({
    url: `/home/view`,
  })
}

// 22/04/02 信用修复
export function creditRepairs(data) {
  return request({
    url: `/creditRepairs`,
    method: 'post',
    data,
  })
}

export function myCreditRepairs(data) {
  return request({
    url: `/creditRepairs/my`,
    method: 'get',
    params: data,
  })
}

export function repairDetail(data) {
  return request({
    url: `/creditRepairs/${data.id}`,
  })
}

export function cancelRepair(data) {
  return request({
    url: `/creditRepairs/${data.id}/cancel`,
    method: 'put',
  })
}

export function creditRepairsPage(data) {
  return request({
    url: `/creditRepairs/page`,
    method: 'get',
    params: data,
  })
}

export function repairByDate(data) {
  return request({
    url: `/creditRepairs/findByDate`,
    method: 'get',
    params: { date: data.id },
  })
}

// 企业评分
export function scoreList(data) {
  return request({
    url: `/creditScoreRecord/pageEnterpriseScoreRecord`,
    method: 'post',
    data,
    // contentType: 'application/x-www-form-urlencoded'
  })
}

export function score(data) {
  return request({
    url: `/creditScoreRecord/queryScoreByEnterpriseCode/${data.enterpriseCode}`,
    method: 'get',
  })
}

export function peopleScore(data) {
  return request({
    url: `/creditPersonalScoreRecord/queryScoreByIdNumber/${data.idNumber}`,
    method: 'get',
  })
}
export function peopleScoreList(data) {
  return request({
    url: `/creditPersonalScoreRecord/pageScoreRecord`,
    method: 'post',
    data,
  })
}

export function certificationInfo() {
  return request({
    url: `/members/certification/get`,
    method: 'get',
  })
}

// 提交自主申报
export function setDeclareInfo(data) {
  return request({
    url: '/creditMemberEnterpriseClaims/create',
    method: 'post',
    data,
  })
}

// 查询省市级别
export function getAddressData(value) {
  return request({
    url: `/system/Area/${value || '-1'}`,
    method: 'get',
  })
}

// 获取PDF文件
export function getPdfFile(data) {
  return request({
    url: `/export/exportReportPdf`,
    method: 'get',
    responseType: 'blob',
    params: data,
  })
}
